if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.productParentElement = this.closest(
          `[data-section][data-product]`
        );
        this.dataset.section = this.productParentElement.dataset.section;
        this.dataset.product = this.productParentElement.dataset.product;

        this.form = this.querySelector("form");
        this.form.querySelector('[name="id"]').disabled = false;

        this.informationModal = document.querySelector("information-modal");

        this.atcButtons = this.productParentElement.querySelectorAll(
          'product-buttons [type="submit"]'
        );
      }

      connectedCallback() {
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        Shopify?.PaymentButton?.init()
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.productParentElement.dataset.variantSelected === "false") {
          const submitter = evt.submitter || evt.submitterPolyfill;

          this.handleErrorMessage(window.variantStrings.selectVariant);
          return;
        }

        this.handleAtcButtonStates("loading");

        this.handleErrorMessage();

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        // redeclare form to gather updater inputs
        this.form = this.querySelector("form");

        const formData = new FormData(this.form);

        this.dynamicSectionsNodes = document.querySelectorAll("cart-dynamic");

        let dynamicSections = [];
        if (this.dynamicSectionsNodes) {
          dynamicSections = [...this.dynamicSectionsNodes].map(
            (item) => item.dataset.sectionId
          );
        }

        formData.append("sections", dynamicSections.join(","));
        // formData.append("quantity", this.querySelector('[name="quantity"]').value)
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              let errorMessage = "";
              // if response description is a string
              if (typeof response.description === "string") {
                errorMessage = response.description;
              } else {
                Object.keys(response.description).forEach((key) => {
                  if (key !== "status" && key !== "sections") {
                    errorMessage += `${response.description[key]}\n`;
                  }
                });
              }

              this.handleErrorMessage(errorMessage);
              this.handleAtcButtonStates("error");
              // this.productParentElement.dataset.variantSelected = false;
              return;
            }

            // update dynamic sections
            this.dynamicSectionsNodes.forEach((node) => {
              const htmlString = response.sections[node.dataset.sectionId];
              const html = new DOMParser().parseFromString(
                htmlString,
                "text/html"
              );
              node.innerHTML = html.querySelector(
                `cart-dynamic[data-section-id='${node.dataset.sectionId}']`
              ).innerHTML;
              node.classList = html.querySelector(
                `cart-dynamic[data-section-id='${node.dataset.sectionId}']`
              ).classList;
              node.modified();
            });

            this.handleAtcButtonStates("success");
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {});
      }

      handleAtcButtonStates(state) {
        this.atcButtons.forEach((button) => {
          switch (state) {
            case "loading":
              if (button.dataset.state == "loading") return;
              button.setAttribute("aria-disabled", true);
              button.dataset.state = "loading";
              break;

            case "error":
              button.dataset.state = "error";
              button.removeAttribute("aria-disabled");
              navigator.vibrate(100);
              setTimeout(() => button.removeAttribute("data-state"), 3000);
              break;

            case "success":
              button.dataset.state = "success";
              button.removeAttribute("aria-disabled");
              navigator.vibrate(100);
              setTimeout(() => button.removeAttribute("data-state"), 3000);
              break;
          }
        });
      }
      handleStickySubmit(submitter) {
        if (submitter.closest("sticky-mobile")) {
          const mobileFormDrawer = this.productParentElement.querySelector(
            `drawer-element[id^="product-form-template"]`
          );
          mobileFormDrawer.openDrawer();
          return;
        }

        if (submitter.closest("sticky-desktop")) {
          const variantSelector = submitter
            .closest("sticky-desktop")
            .querySelector(".variant-selector");
          variantSelector.classList.add(
            "outline",
            "outline-offset-2",
            "outline-2",
            "outline-highlight-red"
          );

          variantSelector.addEventListener("click", () => {
            variantSelector.classList.remove(
              "outline",
              "outline-offset-2",
              "outline-2",
              "outline-highlight-red"
            );
          });
          return;
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrappers =
          this.errorMessageWrappers ||
          this.productParentElement.querySelectorAll("error-message");

        this.errorMessageWrappers.forEach((errorMessageWrapper) => {
          if (errorMessage) {
            const errorMessageOutput =
              errorMessageWrapper.querySelector("span");
            errorMessageOutput.textContent = errorMessage;
            errorMessageWrapper.classList.remove("hidden");
            setTimeout(() => {
              errorMessageWrapper.classList.add("hidden");
            }, 3000);
          } else {
            errorMessageWrapper.classList.add("hidden");
          }
        });
      }
    }
  );
}
